import { useEffect } from "react";
import { useGetIdentity, useListContext } from "ra-core";
import { useNavigate, useSearchParams } from "react-router";

import { useConfigurationContext } from "../root/ConfigurationContext";
import {
  buildQuickFilterValues,
  NO_QUICK_FILTERS,
  type SponsoringQuickFilters as QuickFilterState,
} from "./sponsoringFilters";

/** `?filter=` values accepted by links from the dashboard */
const QUICK_FILTER_PARAMS: Record<string, keyof QuickFilterState> = {
  active: "currentlyActive",
  not_expired: "notExpired",
  expired: "expired",
  ending_soon: "endingSoon",
  closed: "showClosed",
  mine: "onlyMine",
};

/**
 * Deep links such as /sponsorings?filter=expired (from the dashboard) select
 * that quick filter, after which the parameter is dropped from the URL.
 * Shared by the desktop table and the mobile list, which both keep their
 * filters out of the location (`disableSyncWithLocation`).
 */
export const useQuickFilterParam = (basePath = "/sponsorings") => {
  const { setFilters } = useListContext();
  const config = useConfigurationContext();
  const { identity } = useGetIdentity();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requestedFilter = searchParams.get("filter");

  useEffect(() => {
    if (!requestedFilter) return;
    const key = QUICK_FILTER_PARAMS[requestedFilter];
    if (key) {
      setFilters(
        buildQuickFilterValues({
          config,
          quickFilters: { ...NO_QUICK_FILTERS, [key]: true },
          identityId: identity?.id,
        }),
        undefined,
        false,
      );
    }
    navigate({ pathname: basePath, search: "" }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedFilter]);
};
